// extracted by mini-css-extract-plugin
export default {"home_container":"Home_home_container__1eV0a","big_bottom_img_div":"Home_big_bottom_img_div__kf6K1","Carouselcontainer":"Home_Carouselcontainer__MJaRy"};